module.exports = __webpack_public_path__ + "static/media/truck.ff6c5688.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/truck.png
// module id = 315
// module chunks = 0